export const PAGE_CONTAINER_ID = 'pageContainer';
